import React, { useContext } from 'react';
import { useMount, useUnmount } from 'react-use';

import { removeTrailingSlash } from '@mssgme/shared';

const joinPath = (a, b) => {
    return (
        '/' + removeTrailingSlash(`${removeTrailingSlash(a)}/${removeTrailingSlash(b, { lead: true })}`, { lead: true })
    );
};

export const makeCoreRouter = ({ path, isBackOverriddenBack }) => {
    const base = removeTrailingSlash(path);

    return {
        toEntry: () => path,
        toHome: () => path,
        product: {
            toView: (productSlug = ':productSlug') => joinPath(base, `p/${productSlug}`),
        },
        collection: {},
        orders: {
            toView: (orderId = ':orderId', basePath = base) =>
                joinPath(basePath, orderId ? `orders/${orderId}` : 'orders'),
            toStatus: (orderId = ':orderId', status = ':status(paid|failed)') =>
                joinPath(base, `orders/${orderId}/payment/${status}`),
        },
        userOrders: {
            toOrder: (orderId = ':orderId') => joinPath(base, orderId ? `user-orders/${orderId}` : 'orders'),
        },
        isBackOverriddenBack,
    };
};

export const CoreContext = React.createContext({
    path: '/',
    router: makeCoreRouter({ path: '/' }),
    setEntry: () => {},
});

export const useBackCorePath = (backUrl) => {
    const { setEntry } = useCoreContext();

    useMount(() => setEntry(backUrl));
    useUnmount(() => setEntry());
};

export const useCoreContext = () => useContext(CoreContext);
